import script from "./ChambrePaliereView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChambrePaliereView.vue?vue&type=script&setup=true&lang=js"

import "./ChambrePaliereView.vue?vue&type=style&index=0&id=0f6c89e6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6c89e6"]])

export default __exports__